import { BannerEffects } from './banner.effects';
export const effects: any[] = [BannerEffects];
